<div class="form-group row">
  <label class="col-sm-3 col-form-label" *ngIf="label">{{ label }}</label>
  <div class="col-sm-9">
    <input nbInput
      fullWidth
      [placeholder]="placeholder"
      [nbDatepicker]="formcontrol"
      [formControl]="control"
      [status]="(control.invalid && control.touched) ? 'danger' : 'basic'"
      class="date-picker-icon"
    >
    <nb-datepicker #formcontrol [format]="dateFormat" [min]="min" [max]="max"></nb-datepicker>
    <span [ngxAppValidationMessageFor]="control" class="error-message">
    </span>
  </div>
</div>
